
<template>
    <div id="Contact" class="wrap">
        <div class="contact">
            <div class="title">
                <h2>Contact</h2>
            </div>  
            <div class="row">
                <div class="col-12 col-md-7">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d197.78112493987146!2d127.02396822833668!3d37.519756476080595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3ec80361177%3A0x70f458a97cd43926!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDrhbztmITroZwxNTHquLggNTA!5e0!3m2!1sko!2skr!4v1638850590930!5m2!1sko!2skr" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                </div>
                <div class="col-12 col-md-5">
                    <table>
                        <tbody class="box">
                            <tr style="color:blue;"><th>지원문의</th></tr>
                            <tr><th><b-icon icon="telephone"></b-icon>02-512-0982</th></tr>
                            <tr><th><b-icon icon="envelope"></b-icon>apply@vers.kr</th></tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody class="box">
                            <tr style="color:blue; "><th>기타문의</th></tr>
                            <tr><th><b-icon icon="telephone"></b-icon>02-512-0982</th></tr>
                            <tr><th><b-icon icon="envelope"></b-icon>vers.companyofficial@gmail.com</th></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {

}
</script>


<style lang="scss">
#Contact{ 
    .contact { margin-bottom: 15%;
        .title{margin: 90px 0 0 0; }
        .col-md-5{padding-left: 60px;
            table{font-size: 20px; margin-bottom: 10%; font-weight: 300; margin-top: -15px;
                .box{
                    tr{line-height:2;}
                    .b-icon{margin-right: 20px;}
                }
            }
        }
    }
}
@media(max-width:767px) {
    #Contact{
        .contact{padding-bottom: 118px; padding-left: 10px; padding-right: 10px;
             .title{margin: 10px 0 0 10px; 
                h2{margin-bottom: 10px;}
            }
            iframe{width: 100%; height: 100%; padding: 15px 0px 0px 0px;}
            .col-md-5{padding: 15px 3px 3px 11px;
                table{font-size: 15px; margin: 0%; 
                }
            }
        }
    }
}
</style>